import styled from "styled-components";
export const HotelWrapper = styled.div`
  --pou-card-bg: #ffffff;
  --pou-card-border: #e2e5ed;
  --pou-accent-blue: #37a7cd;
  --pou-available-green: #2e9b4e;
  --pou-warning-red: #d93025;
  --pou-text-main: #202634;
  --pou-text-muted: #6d7280;
  --pou-header-height: 68px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0px;
  display: flex;
  flex-direction: column;
  background: #f5f6fa;

  .hotel-booking-timer {
    background: #fff7ed;
    border: 1px solid #fed7aa;
    color: #9a3412;
    font-weight: 700;
    padding: 12px 16px;
    border-radius: 10px;
    margin: 12px 0 16px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    span {
      color: #c2410c;
      font-weight: 800;
    }
  }

  .hotel {
    position: relative;
    flex: 1;
    @media only screen and (max-width: 1200px) {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    &-body {
      display: grid;
      grid-template-columns: 320px 1fr;
      gap: 18px;
      position: absolute;
      inset: 0;
      padding: 18px 18px 0;
      overflow: hidden;
      @media only screen and (max-width: 1200px) {
        grid-template-columns: 1fr;
        position: relative;
        inset: auto;
        overflow: visible;
      }
    }
    &-left {
      overflow: hidden;
      overflow-y: auto;
      background-color: #ffffff;
      border-radius: 12px;
      box-shadow: 0 12px 28px rgba(15, 44, 92, 0.12);
      border: 1px solid #e4e8f0;
      transform: translateX(0);
      transition: all 0.35s ease;
      position: sticky;
      top: 12px;
      height: calc(100vh - 40px);

      @media only screen and (max-width: 1200px) {
        position: fixed;
        inset: var(--pou-header-height) auto 0 0;
        width: 320px;
        max-width: 85vw;
        height: calc(100vh - var(--pou-header-height));
        z-index: 1001;
        box-shadow: 0 6px 16px rgba(15, 44, 92, 0.12);
      }
    }

    &-right {
      background-color: #fff;
      padding: 0px;
      display: flex;
      flex-direction: column;
      width: 400px;
      background-color: #f8f8f8;
      transform: translateX(0);
      transition: all 0.35s ease;
      @media only screen and (max-width: 1200px) {
        position: absolute;
        z-index: 100;
        top: 0;
        right: 0;
        bottom: 0;
      }
      @media only screen and (max-width: 600px) {
        width: 100%;
      }
    }
    &-main {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
      width: 100%;
      gap: 14px;
      padding: 0 12px 18px;
      max-width: 1200px;
      margin: 0 auto;
      @media only screen and (max-width: 1200px) {
        overflow: visible;
      }
      @media only screen and (max-width: 600px) {
        padding: 0;
      }
    }
    &-title {
      width: 100%;
      text-align: center;
      font-size: 21px;
      margin: 0px auto;
      color: #0c3d72;
      padding: 20px;
      font-weight: 700;
      background-color: #ffffff;
    }
    &-promo-banner {
      width: 100%;
      padding: 18px 24px;
      border-radius: 12px;
      background: linear-gradient(90deg, #5ca8cb 0%, #6db8d8 100%);
      color: #ffffff;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      line-height: 1.35;
      box-shadow: 0 12px 28px rgba(15, 44, 92, 0.12);
      border: 1px solid rgba(255, 255, 255, 0.2);

      .highlight {
        color: #ffd34d;
        font-weight: 800;
      }

      @media only screen and (max-width: 900px) {
        font-size: 16px;
        padding: 14px 16px;
      }

      @media only screen and (max-width: 600px) {
        font-size: 14px;
        line-height: 1.5;
      }
    }
    &-header {
      background: #f3f3f3;
      height: 50px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 12px;
      justify-content: space-between;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 12px 28px rgba(15, 44, 92, 0.12);
      border: 1px solid #e4e8f0;
      min-height: 60px;
      margin: 0 0 8px;
      width: 100%;
      border-radius: 12px;
      position: sticky;
      top: 0;
      z-index: 30;
      &-filter {
        border-right: 1px solid #ffffff;
        button {
          font-size: 18px;
        }
      }
      &-result {
        display: flex;
        gap: 20px;
        align-items: center;
        .hotel-header-count {
          font-size: 15px;
          font-weight: 700;
          color: #0f172a;
        }
        .hotel-header-dates {
          font-size: 13px;
          color: #4b5563;
        }
        > .btn {
          background-color: #0a72d8;
          border-color: #0a72d8;
          color: #fff;
          text-align: center;
          border-radius: 8px;
          font-size: 14px;
          height: 36px;
          line-height: 18px;
        }
      }
      &-sorting {
        flex: 1;
        text-align: right;
        padding-right: 12px;
        .title {
          font-size: 14px;
          color: #22335d;
          padding-right: 10px;
        }
        .ant-select:not(.ant-select-customize-input) .ant-select-selector {
          position: relative;
          background-color: transparent;
          border: none;
          border-radius: 8px;
          width: 210px;
          text-align: left;
          box-shadow: 0 6px 16px rgba(15, 44, 92, 0.12);
          padding: 0px 8px;
          border: 1px solid #e4e8f0;
        }
      }

      @media (min-width: 1200px) {
        padding-left: 20px;
      }
      @media (max-width: 600px) {
        flex-wrap: wrap;
        height: auto;
        padding: 10px 12px;
        gap: 8px;
        &-sorting {
          width: 100%;
          text-align: left;
          padding-right: 0;
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: flex-end;
        }
        &-sorting
          .ant-select:not(.ant-select-customize-input)
          .ant-select-selector {
          width: 100%;
        }
      }
    }
    &-booking-details {
      background-color: #fff;
      position: absolute;
      bottom: 0;
      padding: 0px;
      left: 0;
      right: 0;
      box-shadow: 0px -1px 6px 1px rgb(64 87 109 / 22%);
      z-index: 80;
      text-align: center;
      border-top: 1px solid #cfcfcf;
      padding: 10px;
      &-btn {
        height: 80px;
        width: 100%;

        font-size: 15px;
        font-family: "Avenir";
        padding: 0;
        margin: 0;
        &-btn {
          background-color: #1d3bf8;
          height: 64px;
          width: 100%;
          color: #fff;
          font-size: 18px;
          font-family: "Avenir";
          font-weight: 900;
        }
        &-label {
          display: flex;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 10px;
          font-size: 18px;
          span {
            font-weight: 900;
          }
        }
      }
    }
    &-result {
      flex: 1;
      overflow-y: auto;
      padding-bottom: 24px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    &-searchbar {
      background: #0a72d8;
      border-radius: 12px;
      padding: 10px;
      box-shadow: 0 18px 32px rgba(15, 44, 92, 0.14);
      border: 1px solid #0b64b8;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      position: relative;
    }
    &-list {
      padding: 4px 0 18px;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      .ant-list-items {
        display: flex;
        flex-direction: column;
        gap: 0;
      }
      .ant-list-item {
        padding: 0;
        border: none;
      }
    }
  }
  .hide {
    transform: translateX(-100%);
    width: 0;
  }
  .hideRight {
    transform: translateX(100%);
    /* width: 0; */
  }

  @media only screen and (max-width: 1200px) {
    .hotel-body.filters-open::before {
      content: "";
      position: fixed;
      inset: var(--pou-header-height) 0 0 0;
      background: rgba(8, 16, 32, 0.45);
      z-index: 50;
    }
  }

  .hotel-detail {
    overflow-y: auto;
    height: 100%;
    /* overflow-x: hidden; */
    .hotel-body {
      grid-template-columns: minmax(0, 1fr) 360px;
      align-items: flex-start;
      padding: 18px;
      position: relative;
      inset: auto;
      overflow: visible;
      min-height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    .hotel-result {
      max-width: 1200px;
      margin: 0 auto;
      width: 100%;
      overflow: visible;
      padding-bottom: 24px;
    }
    .hotel-right {
      position: sticky;
      top: 12px;
      height: auto;
      box-shadow: 0 12px 28px rgba(15, 44, 92, 0.12);
      border: 1px solid #e4e8f0;
      border-radius: 12px;
    }
    @media only screen and (max-width: 1200px) {
      .hotel-cart-overlay {
        position: fixed;
        inset: 0;
        background: rgba(8, 16, 32, 0.45);
        z-index: 90;
      }
      .hotel-body {
        grid-template-columns: 1fr;
        padding: 18px 12px;
        overflow: visible;
      }
      .hotel-right {
        position: fixed;
        top: auto;
        width: 100%;
        right: 0;
        bottom: 0;
        max-height: 85vh;
        overflow-y: auto;
        background: #fff;
        z-index: 140;
        border-radius: 16px 16px 0 0;
      }
    }
    @media only screen and (max-width: 600px) {
      .hotel-result {
        padding-bottom: 140px;
      }
      .hotel-detail-main {
        padding-bottom: 140px;
      }
      .hotel-booking-details {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 120;
        border-top: 1px solid #cfcfcf;
        box-shadow: 0px -1px 6px 1px rgb(64 87 109 / 22%);
      }
    }
  }
`;
export const PackageViewFrontEndWrapper = styled.div`
  background-color: #f6f8f9;
  padding: 40px 20px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .package-view-frontend {
    &-body {
      display: flex;
      margin: auto;
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
    }
    &-left {
      overflow-y: auto;
      flex: 1;
      padding: 30px;
      @media only screen and (max-width: 600px) {
        padding: 0px;
      }
      /* margin: 0 auto;
      max-width: 1000px; */
    }
    &-right {
      background-color: #fff;
      box-shadow: 0 1px 4px rgb(64 87 109 / 7%);
      padding: 0px;
      width: 400px;
      display: flex;
      flex-direction: column;
      transform: translateX(0);
      transition: all 0.35s ease;
      @media only screen and (max-width: 1200px) {
        position: absolute;
        z-index: 100;
        top: 0;
        right: 0;
        bottom: 0;
      }
      @media only screen and (max-width: 600px) {
        width: 100%;
      }
    }
    &-booking-details {
      background-color: #fff;
      position: absolute;
      bottom: 0;
      padding: 0px;
      left: 0;
      right: 0;
      box-shadow: 0px -1px 6px 1px rgb(64 87 109 / 22%);
      z-index: 80;
      text-align: center;
      border-top: 1px solid #cfcfcf;
      padding: 10px;
      &-btn {
        height: 80px;
        width: 100%;

        font-size: 15px;
        font-family: "Avenir";
        padding: 0;
        margin: 0;
        &-btn {
          background-color: #1d3bf8;
          height: 64px;
          width: 100%;
          color: #fff;
          font-size: 18px;
          font-family: "Avenir";
          font-weight: 900;
        }
        &-label {
          span {
            font-weight: 900;
          }
        }
      }
    }
  }
  .hide {
    transform: translateX(100%);
    width: 0;
  }
`;
